<section id="active-ingredient">
  <div class="title">
    <h1>Active Ingredient</h1>
  </div>
  <div class="desc">
    <h4>
      {{ activeIngredients }}
    </h4>
  </div>

  <div class="content">
    <div class="image">
      <img src="../../../assets/Active Ingredient.svg" alt="" />
    </div>
    <div data-aos="zoom-out-up" data-aos-duration="1000" class="text">
      <p>{{ activeIngredientsDesc }} <span>(01)</span></p>
    </div>

    <div
      *ngIf="videoUrl"
      data-aos="zoom-out-up"
      data-aos-duration="1000"
      class="video"
    >
      <!-- <iframe width="480" height="300" src="https://www.youtube.com/embed/H_7zcFEdVYE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->

      <video playsinline muted loop preload id="vid" #vid>
        <source [src]="videoUrl" />
      </video>
      <div
        *ngIf="videoUrl"
        class="video__controls"
        (click)="onPause($event, vid)"
      >
        <div
          *ngIf="played && vid && !vid.paused"
          class="video__controls__pause"
        >
          \\
        </div>
        <div
          *ngIf="!played && vid && vid.paused"
          class="video__controls__pause"
        >
          >
        </div>
        <div class="video__controls__fullScreen">
          <span class="material-icons"> fullscreen </span>
        </div>
      </div>
    </div>
  </div>
</section>
